<template>
  <div class="renew">
    <sidebar_user :setorders="orders" />
    <section class="home-section">
      <div class="space"></div>
      <b-container>
        <b-row>
          <b-col v-if="books.length === 0">
            <div class="chip">
              <div class="chip__icon">
                <i
                  class="fa-regular fa-face-sad-tear"
                  style="color: Tomato"
                ></i>
              </div>
              <p>ไม่มีรายการยืม</p>
              <div class="chip__close">
                <!-- <ion-icon name="close"></ion-icon> -->
              </div>
           
          </div>
            
            <div class="space1"></div>
          </b-col>
        </b-row>

        <div class="card-columns" v-if="books.length !== 0">
          <div class="card card-order-list card-margin border-light shadow">
            <div class="card-body">
              <div class="card-content-more">
                <div class="row">
                  <div class="col-6">
                    <p class="max">
                      สิทธิ์ยืมต่อเหลือ
                      <strong style="color: #ff5f2d;"> {{ maxRenew }} </strong
                      >ครั้ง
                    </p>
                  </div>
                  <div class="col-6">
                    <button
                      class="btn btn-orange pull-right"
                      v-if="maxRenew != 0"
                      @click="renew()"
                    >
                      ยืมต่อ
                    </button>
                  </div>
                </div>
              </div>
              <br />

              <b-table
                hover
                :items="books"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                id="my-table"
                head-variant="light"
                v-if="books.length !== 0"
                class="text-left"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(timedue)="data">
                  {{ data.item.timedue | moment }}
                </template>
              </b-table>

              <!-- <div class="space"></div> -->
              <hr />
              <div class="pagination-div">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  pills
                  align="right"
                ></b-pagination>
              </div>

              <!--  -->

              <!--  -->
            </div>
          </div>
          <div class="space2"></div>
        </div>
      </b-container>
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
import axios from "axios";
import moment from "moment";
export default {
  name: "renew",
  components: { sidebar_user },
  data() {
    return {
      items: [],
      orders: [],
      user: false,
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      auth: [],
      books: [],
      fields: [
        { key: "index", label: "ลำดับ" },
        { key: "barcode", label: "Barcode", sortable: true },
        { key: "title", label: "ชื่อหนังสือ", sortable: true },
        { key: "timedue", label: "กำหนดส่ง", sortable: true },
      ],
      perPage: 20,
      currentPage: 1,
      maxRenew: "",
      code:''
    };
  },
  computed: {
    rows() {
      return this.books.length;
    },
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      // if (date) {
      //   return moment(String(date)).format("MM/DD/YYYY");
      // }
      return moment(date).add(543, "year").format("LL");
    },
  },
  methods: {
    getorders() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            if (res.data.Orders !== null) {
              this.orders = res.data.Orders;
              for (var i in this.orders) {
                if (this.orders[i].order_status === 5) {
                  this.orders.splice(this.orders.indexOf(this.orders[i]), 1);
                }
              }

              localStorage.setItem("orders", JSON.stringify(this.orders));
              this.show = true;
            }
          }
        });
    },

    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    loadBooking() {
      this.items = JSON.parse(localStorage.getItem("booking"));
    },
    getbook() {
      let ip = localStorage.getItem("IP");

      let data = {
        token: this.token,
        std_code: this.code,
        public_ip: ip,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/get_loan_all",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          if (res.data[0].msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.$isLoading(false);

            this.books = res.data[0].loan_current;
            // console.log(this.books);
            this.maxRenew = res.data[0].loan_summary[0].max_renew;
          }
        });
    },
    renew() {
      let ip = localStorage.getItem("IP");

      let data = {
        token: this.token,
        std_code: this.code,
        public_ip: ip,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/renew", data, {
          headers,
        })
        .then((res) => {
          if (res.data[0].msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.$isLoading(false);
            this.books = res.data[0].loan_current;
            this.maxRenew = res.data[0].loan_summary[0].max_renew;
          }
        });
    },
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      this.getbook();
      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }

      if (localStorage.getItem("orders") != null) {
        this.loadOrder();
      }
    } else {
      this.user = true;
    }
    this.getorders();
    if (localStorage.getItem("booking") != null) {
      this.loadBooking();
    }
  },
};
</script>

<style lang="scss" scoped>
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}

.space {
  height: 50px;
}
.space1 {
  height: 150px;
}
.space2 {
  height: 150px;
}
/* card*/
.card-body {
  font-family: "Kanit", sans-serif;
}
.card-margin {
  margin-bottom: 1.875rem;
}
.card-order-list {
  padding: 5px;
}
.card-margin-orderlist {
  margin-bottom: 1rem;
}
.card-title {
  text-align: left;
  /* text-align: justify; */
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  /* bottom: 5px; */
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
}
.card-content-more {
  position: relative;
}
/**/

.btn-floating {
  position: absolute;
  /* bottom: 5px; */
  right: -8px;
  top: -49px;
  font-size: 10px;
}
.max {
  position: absolute;
  left: 20px;
  top: 20px;
}
.fa-purple {
  color: rgb(29, 172, 7);
}

.page-link {
  color: palevioletred;
}
.p-color {
  background-color: var(--first-color);
  color: #fff;
}

.btn-orange {
  color: #fff;
  border-color: var(--orange-color);
  background-color: var(--orange-color);
}

.btn-orange:hover {
  color: #fff;
  border-color: var(--sub-color);
  background-color:  var(--first-color);
}
.btn-orange:focus,
.btn-orange.focus {
  color: #fff;
  border-color: var(--sub-color);
  background-color:  var(--first-color);
  box-shadow: 0 0 0 0.2rem rgba(180, 108, 72, 0.5);
}
.btn-orange.disabled,
.btn-orange:disabled {
  color: #fff;
  border-color: var(--orange-color);
  background-color: var(--orange-color);
}
.btn-orange:not(:disabled):not(.disabled):active,
.btn-orange:not(:disabled):not(.disabled).active,
.show > .btn-orange.dropdown-toggle {
  color: #fff;
  border-color: var(--orange-color);
  background-color: var(--sub-color);
}
.btn-orange:not(:disabled):not(.disabled):active:focus,
.btn-orange:not(:disabled):not(.disabled).active:focus,
.show > .btn-oprange.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(180, 108, 72, 0.5);
}

/*  CHIP  */
.chip {
  grid-column: 2 / 3;
  grid-row: 3 / 4;
  justify-self: center;
  width: 20rem;
  height: 4rem;
  border-radius: 1rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__icon {
    width: 3rem;
    height: 3rem;
    border-radius: 1rem;
    margin: 0 0 0 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
    color: var(--primary);
  }

  p {
    font-size: 1.1rem;
    margin-left: -1rem;
    color: #000;
    margin-top: 18px;
  }

  &__close {
    width: 1.6rem;
    height: 1.6rem;
    margin: 0 0.5rem;
    display: flex;
    font-size: 1.6rem;
    color: var(--greyLight-3);
    cursor: pointer;
  }
}
/**/
</style>
